import React from 'react';
import { useScroll } from '../../hooks';
import { PullRefreshIndicator } from './pull-refresh-indicator';
import './pull-refresh-container.scss';

type PullRefreshContainerProps = {
  children: React.ReactNode;
  className?: string;
  onRefresh?: () => Promise<void> | void;
  onHardRefresh?: () => Promise<void> | void;
  onScroll?: React.UIEventHandler<HTMLDivElement>;
};

export const PullRefreshContainer: React.FC<PullRefreshContainerProps> = ({
  children,
  className = '',
  onRefresh,
  onHardRefresh,
  onScroll,
}) => {
  const {
    scrollRef,
    refreshState,
    contentStyle,
    showPullIndicator,
    handleTouchStart,
    handleTouchEnd,
  } = useScroll({
    onRefresh,
    onHardRefresh,
    enabled: !!onRefresh,
  });

  return (
    <div
      className="pull-refresh-container"
      ref={scrollRef}
      onScroll={onScroll}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      style={contentStyle}
    >
      <PullRefreshIndicator
        refreshState={refreshState}
        visible={showPullIndicator}
      />
      <div className={`pull-refresh-container-content  ${className}`}>
        {children}
      </div>
    </div>
  );
};
